module.exports = __webpack_public_path__ + "assets/img/6.7ac7b97d.jpg";